import React from 'react'
import { Container } from 'react-bootstrap'
import Slider from 'react-slick'
import ArrowLeftIcon from '../../../icons/arrow-left'
import ArrowRightIcon from '../../../icons/arrow-right'
import { ProductCard } from '../../products/ProductCard/ProductCard'

function NextArrow(props) {
  const { className, style, onClick } = props
  return (
    <ArrowRightIcon
      className={className}
      style={{ ...style, height: '52px', width: '24px', right: '-45px' }}
      onClick={onClick}
    />
  )
}

function PrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <ArrowLeftIcon
      className={className}
      style={{ ...style, height: '52px', width: '24px', left: '-45px' }}
      onClick={onClick}
    />
  )
}

const ReleatedCarousel = ({ products, showAddToCart = false }) => {
  //Setting slides to show based on card has an showAddToCart button
  const SlideNumber = showAddToCart ? 3 : 4

  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: products.length < SlideNumber ? products.length : SlideNumber,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1180,
        settings: {
          slidesToShow: products.length < 2 ? products.length : 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }
  return (
    <Container className='related-carousel'>
      <Slider {...settings}>
        {products.map((product, index) => {
          return (
            <ProductCard
              product={product}
              key={`${product.id}+${index}`}
              eager={index === 0}
              showAddToCart={showAddToCart}
            />
          )
        })}
      </Slider>
    </Container>
  )
}

export default ReleatedCarousel
